import React from "react";
import { numToDay } from "../../utils/time";
import range from "../../utils/range";
import SwipeToToggle from "./";
import Round from "../Buttons/Round/index";

const allDays = range(1, 6).concat([6, 0]);

export default ({ loading, days = [], onChange }) => (
  <SwipeToToggle
    className="text-left d-flex flex-row flex-wrap"
    handleDragOver={day => onChange(Number(day))}
    selector="day"
  >
    {(allDays || []).map((day, i) => (
      <span   key={i} className="d-flex flex-column align-items-center" >
        <Round
          disabled={loading}
          day={day}
          fontSize={18}
          className="m-1"
          active={days.includes(day)}
          onClick={() => onChange(day)}
        >
        { "✓" }
        </Round>
        <span className="m-1 text-blue bold" >
          { numToDay(day) }
        </span>
      </span>
    ))}
  </SwipeToToggle>
);





// WEBPACK FOOTER //
// ./src/components/SwipeToggle/days.js